import React from 'react';
import '../styles/PanelVertical.css'; 

const PanelVertical = ({ children, height }) => {
  return (
    <div className="panel-vertical" style={{ height: height }}>{children}</div>
  );
};

//{icon && <div className={buttonIcon}><img src={icon} alt="Icon" height={"50%"} /><div className="button-panel-text">{children}</div></div>}

export default PanelVertical;